import React from 'react';
import {connect} from 'react-redux';
import ConfirmationModal from '../components/ConfirmationModal';
import {obterProdutos, adicionarProduto, editarProduto, deletarProduto} from '../actions/ProdutoActions';

class Produtos extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      selecionado: null,
      operacao: "adicionar",
      produto: {
        nome: "",
        descricao: "",
      }
    }
  }

  componentWillMount(){
    this.props.obterProdutos();
  }

  componentDidMount(){
    window.iniciarDataTable();
  }

  componentWillUpdate(){
    window.destruirDataTable();
  }

  componentDidUpdate(){
    window.desenharDataTable();
  }

  alterarForm(event){
    const campo = event.target.name;
    const produto = this.state.produto;
    produto[campo] = event.target.value;
    return this.setState({produto});
  }

  resetar(){
    this.setState({
      operacao: "adicionar",
      produto: {
        nome: "",
        descricao: "",
      }
    });
  }

  editar(){
    this.setState({
      operacao: "editar",
      produto: {
        nome: this.state.selecionado.nome,
        descricao: this.state.selecionado.descricao
      }
    });
  }

  salvar(event){
    event.preventDefault();
    if(this.state.operacao==="adicionar"){
      this.props.adicionarProduto(this.state.produto);
    }else{
      this.props.editarProduto(this.state.produto, this.state.selecionado.id);
    }
    this.resetar();
  }

  deletar(){
    this.props.deletarProduto(this.state.selecionado.id);
    this.setState({selecionado: null});
  }

  render(){
    return(
      <div>
        <ConfirmationModal ref="modal" confirmButtonStyle="btn-danger" title="Deletar produto" confirmButton="Deletar produto" body="Tem certeza que deseja deletar este produto?" onConfirm={this.deletar.bind(this)}/>
        <div className="box">
          <div className="box-body">
            <div className="table-responsive">
              <table id="datatable" className="table table-bordered table-hover">
                <thead>
                  <tr>
                    <th>id</th>
                    <th>Nome</th>
                    <th>Descrição</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    this.props.produtos.map((produto) => (
                      <tr key={produto.id} style={{cursor: "pointer"}} onClick={() => this.setState({selecionado: produto})} className={this.state.selecionado===produto ? "info" : null}>
                        <td>{produto.id}</td>
                        <td>{produto.nome}</td>
                        <td>{produto.descricao}</td>
                      </tr>
                    ))
                  }
                </tbody>
              </table>
            </div>
          </div>
          <div className="box-footer">
            <div className="pull-right">
              <i className="fa fa-fw fa-2x fa-spinner fa-spin vcenter" style={this.props.carregando ? {display: ""} : {display: "none"}}></i>
              <button style={{marginLeft: 10}} className="vcenter btn btn-success flat" data-toggle="modal" data-target="#modal" onClick={this.resetar.bind(this)}>Adicionar</button>
              <button style={{marginLeft: 10}} data-toggle="modal" data-target="#modal" onClick={this.editar.bind(this)} disabled={this.state.selecionado ? false : true} className="vcenter btn btn-warning flat">Editar</button>
              <button style={{marginLeft: 10}} className="vcenter btn btn-danger flat" disabled={this.state.selecionado ? false : true} onClick={() => this.refs.modal.open()}>Deletar</button>
            </div>
          </div>
        </div>

        <div id="modal" className="modal fade">
          <form onChange={this.alterarForm.bind(this)} onSubmit={this.salvar.bind(this)}>
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                  <h4 className="modal-title">Produto</h4>
                </div>
                <div className="modal-body">
                  <div className="form-group">
                    <label htmlFor="nome">Nome</label>
                    <input required type="text" value={this.state.produto.nome} className="form-control" name="nome" />
                  </div>
                  <div className="form-group">
                    <label htmlFor="descricao">Descrição</label>
                    <input required type="text" value={this.state.produto.descricao} className="form-control" name="descricao" />
                  </div>
                </div>
                <div className="modal-footer">
                  <button name="salvar"
                    type="submit"
                    className="btn btn-primary flat pull-left"
                    >
                    Salvar
                  </button>
                  <button name="cancelar"
                    type="button"
                    className="btn btn-default flat"
                    data-dismiss="modal">
                    Cancelar
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    produtos: state.produto.todos,
    carregando: state.produto.carregando,
    erro: state.produto.erro
  };
}

export default connect(mapStateToProps, {obterProdutos, adicionarProduto, editarProduto, deletarProduto})(Produtos);



// WEBPACK FOOTER //
// ./src/views/Produtos.js